"use client";
import React, { useState } from "react";
import useFetchPost from "../hooks/useFetchPost";
import Swal from "sweetalert2";

import { toast, Bounce } from "react-toastify";

const Confirm = ({ data }) => {
	const { fetchPostData, error } = useFetchPost();
	const [isStandardChecked, setIsStandardChecked] = useState(false);

	const handleClose = () => {
		const confirmModal = document.getElementById("confirmModal");
		confirmModal.classList.remove("show");
		confirmModal.style.display = "none";
	};
	const handleCheckboxChange = (event) => {
        setIsStandardChecked(event.target.checked);
    };
	// Function to handle data submission
	const handleSubmit = async () => {
		// Process the data or perform any actions
		const postData = {
			product_key: data && data.product_key,
			user_uuid: data && data.user_uuid,
			key: data && data.type,
			server: data && data.server,
			muvi_userid: data && data.muviUserId,
			standard: isStandardChecked,
		};
		if (data.isMuvi5) {
			var win = window.open(
				data.studioUrl +
					"/login/storeLogin" +
					"?email=" +
					data.email +
					"&password=" +
					data.password +
					"&studio_id=" +
					data.studio_id +
					"&muviEmployeeId=" +
					data.muviUserId,
				"_blank"
			);
		} else {
			let crmStagingUrl = process.env.REACT_APP_CRM + "/muvi6/auto-login";
			let responseData;
			try {
				responseData = await fetchPostData(crmStagingUrl, postData);
				//console.log("Response:", responseData);
			} catch (error) {
				console.error("Error:", error);
			}

			if (responseData && responseData.code == 200) {
				window.open(responseData.data, "_blank");
			} else {
				const errorMessage = responseData && responseData.message ? responseData.message : "An error occurred";

				toast.error(errorMessage, {
					position: "top-right",
					autoClose: 1000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "light",
					transition: Bounce,
				});
				// Action to take if user clicks "Cancel" or closes the dialog
				console.warn("Something went wrong to fetching data for auto login.");
			}
		}

		// Close the modal
		const confirmModal = document.getElementById("confirmModal");
		confirmModal.classList.remove("show");
		confirmModal.style.display = "none";
	};

	return (
		<div className="modal fade" id="confirmModal" tabindex="-1" role="dialog" aria-labelledby="confirmModalLabel">
			<div className="modal-dialog" role="document">
				<div className="modal-content">
					<div className="modal-header">
						<button
							type="button"
							className="close"
							data-dismiss="modal"
							aria-label="Close"
							onClick={handleClose}
						>
							<span aria-hidden="true">&times;</span>
						</button>
						<h4 className="modal-title" id="confirmModalLabel" style={{ color: "rgb(87, 87, 87)" }}>
							Login To Account
						</h4>
					</div>
					<div className="modal-body">
						<h5 style={{ color: "rgb(87, 87, 87)" }}>{data && data.confirmText}</h5>
					</div>
					<div className="modal-footer check-box">
                        <div className="d-flex justify-content-between align-items-center">
                            {data && data.product_key == process.env.REACT_APP_MUVI_ONE_PRODUCT_KEY && (
                                <div className="form-check log-in">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="flexCheckDefault"
                                        onChange={handleCheckboxChange}
                                    />
                                    <label className="form-check-label" htmlFor="flexCheckDefault">
                                        Take me to Staging account.
                                        <svg
                                            className="info-icon"
                                            width="10"
                                            height="10"
                                            viewBox="0 0 10 10"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <circle cx="5" cy="5" r="5" fill="#303049" />
                                            <text
                                                x="5"
                                                y="7"
                                                fill="white"
                                                fontSize="6"
                                                textAnchor="middle"
                                                fontWeight="bold"
                                            >
                                                i
                                            </text>
                                        </svg>
                                        <div className="custom-tooltip">
                                            This option is primarily used by the CS team. If no staging account exists for this
                                            customer, you will be redirected to the live account by default.
                                        </div>
                                    </label>
                                </div>
                            )}
                            <div className={`checkbox d-flex ${!(data && data.product_key === process.env.REACT_APP_MUVI_ONE_PRODUCT_KEY) ? 'ml-auto' : ''}`}>
                                <button type="button" className="btn btn-blue" data-dismiss="modal" onClick={handleClose}>
                                    Close
                                </button>
                                <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={handleSubmit}>
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
				</div>
			</div>
		</div>
	);
};

export default Confirm;



// WEBPACK FOOTER //
// ./src/components/crm/modals/Confirm.jsx